import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IRecords, ICCRecords, IECRecords, IAchievementRecords, IHobbies, IProjects, IContact } from './records';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class RecordsService {

  private _url: string = "/assets/a_records/a_records.json";
  private cca_url: string = "/assets/a_records/cc_activity.json";
  private eca_url: string = "/assets/a_records/ec_activity.json";
  private ach_url: string = "/assets/a_records/achievement.json";
  private hob_url: string = "/assets/a_records/hobbie_list.json";
  private proj_url: string ="/assets/a_records/project_list.json";
  private cont_url: string ="/assets/a_records/contact_records.json";

  constructor(private http:HttpClient) { }

  getRecords(): Observable<IRecords[]>{
    return this.http.get<IRecords[]>(this._url);
  }
  getCCRecored(): Observable<ICCRecords[]>{
    return this.http.get<ICCRecords[]>(this.cca_url);
  }
  getECRecord(): Observable<IECRecords[]>{
    return this.http.get<IECRecords[]>(this.eca_url);
  }
  getAchRecord(): Observable<IAchievementRecords[]>{
    return this.http.get<IAchievementRecords[]>(this.ach_url);
  }
  getHobRecord(): Observable<IHobbies[]>{
    return this.http.get<IHobbies[]>(this.hob_url);
  }
  getProjRecord() : Observable<IProjects[]>{
    return this.http.get<IProjects[]>(this.proj_url);
  }
  getContRecord(): Observable<IContact[]>{
    return this.http.get<IContact[]>(this.cont_url);
  }
}
